export const theme = {
    colors: {
        // Primary colors - Enhanced pink palette
        primary: '#e91e63', // Vibrant pink
        primaryDark: '#c2185b', // Darker pink
        primaryLight: '#f48fb1', // Light pink
        secondary: '#EC4899', // Pink accent
        
        // Background colors
        background: '#FDF2F8', // Soft pink background
        backgroundLight: '#FCE7F3', // Lighter pink
        backgroundDark: '#F3E8FF', // Soft purple background
        
        // Text colors
        text: '#1F2937', // Dark gray for readability
        textLight: '#6B7280', // Medium gray
        textDark: '#111827', // Very dark gray
        white: '#FFFFFF', // Pure white
        
        // Accent colors
        accent1: '#F59E0B', // Warm amber
        accent2: '#10B981', // Emerald green
        accent3: '#3B82F6', // Blue
        accent4: '#EF4444', // Red
        
        // Status colors
        success: '#10B981',
        warning: '#F59E0B',
        error: '#EF4444',
        info: '#3B82F6',
        
        // Neutral colors
        gray: '#F3F4F6',
        grayLight: '#F9FAFB',
        grayDark: '#9CA3AF',
        
        // Legacy colors for backward compatibility
        dark: '#4f003e',
        darkLight: '#4f003e',
        rose: '#ef4444',
        roseLight: '#f87171',
    },
    fonts: {
        light: '300',
        regular: '400',
        medium: '500',
        semibold: '600',
        bold: '700',
        extraBold: '800',
    },
    radius: {
        xs: 8,
        sm: 12,
        md: 16,
        lg: 20,
        xl: 24,
        xxl: 32,
    },
    shadows: {
        small: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 3,
        },
        medium: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.15,
            shadowRadius: 8,
            elevation: 6,
        },
        large: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 8 },
            shadowOpacity: 0.2,
            shadowRadius: 16,
            elevation: 12,
        },
    },
    spacing: {
        xs: 4,
        sm: 8,
        md: 16,
        lg: 24,
        xl: 32,
        xxl: 48,
    }
}